import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { NavigationMenuItem } from "@idw-types/common";
import styles from "./navigation-menu-list-item-content.less";

type NavigationMenuListItemContentProps = {
    collapsedHorizontally: boolean;
    item: NavigationMenuItem;
    expanded: boolean;
};

export const NavigationMenuListItemContent = (props: NavigationMenuListItemContentProps) => {
    const { collapsedHorizontally, item, expanded } = props;

    return (
        <div className={styles.navigationMenuListItemContent}>
            {item.icon && (
                <FontAwesomeIcon className={styles.navigationMenuListItemIcon} icon={item.icon} />
            )}
            {!collapsedHorizontally && (
                <span>{item.title}</span>
            )}
            {item.children && (
                <FontAwesomeIcon className={`${styles.navigationMenuListItemChevron} ${!expanded && styles.rotate}`} icon={faChevronUp} />
            )}
        </div>
    );
};